// src/components/NameScreen.js
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FormContext } from "../context/FormContext";
import Header from "./Header";

const NameScreen = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const { updateFormData } = useContext(FormContext);

   const handleNext = () => {
    if (name.trim()) {
      updateFormData({ name });
      navigate("/email");
    }
  };

  return (
    <div>
      <Header />
      <div className="center flex flex-col items-center h-screen">
        <div className="flex flex-col items-start justify-center w-full h-screen gap-6 max-w-xs md:max-w-md">
          <div className="flex flex-col items-start">
            <h2 className="text-[#0D3C26] font-bold text-xl md:text-2xl">
              Hello! I'm Bew.
            </h2>
            <h2 className="text-[#0D3C26] font-bold text-xl md:text-2xl">
              What's your name
            </h2>
          </div>

          <p className="text-[#0D3C26] text-xl">
            I take data privacy very seriously. We never share your data for ads
            or marketing.
          </p>
          <div className="w-full rounded-full flex bg-white px-4 justify-between items-center h-14">
            <input
              type="Enter your name"
              className="placeholder:text-[#0d3c26b2] w-full  focus:outline-none outline-none text-[#0D3C26] text-base md:text-xl "
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
            />
            <button className="bg-[#FAF3EA] rounded-full p-2  text-center flex justify-center items-center" disabled={!name} onClick={handleNext}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19.9952 12.3828C20.0437 12.2658 20.0707 12.1375 20.0711 12.003V11.997C20.0703 11.7421 19.9727 11.4874 19.7782 11.2929L12.7071 4.22185C12.3166 3.83132 11.6834 3.83132 11.2929 4.22185C10.9024 4.61237 10.9024 5.24554 11.2929 5.63606L16.6569 11L4.92896 11C4.37667 11 3.92895 11.4477 3.92896 12C3.92895 12.5523 4.37667 13 4.92896 13H16.6569L11.2929 18.364C10.9024 18.7545 10.9024 19.3877 11.2929 19.7782C11.6834 20.1687 12.3166 20.1687 12.7071 19.7782L19.7777 12.7076L19.7803 12.705C19.8751 12.6096 19.9468 12.4999 19.9952 12.3828Z" fill={name?`#0D3C26`:`#0d3c26b2`} fill-opacity="0.6"/>
</svg></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NameScreen;
